// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__qOhN6","label":"CategoryService_label__1mzFr","location":"CategoryService_location__1FFgG"};